import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const officeService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/service-office/paginate', {
      params,
    })
    return response.data
  },
  getById: async (id) => {
    const response = await axiosInstance.get('/service-office/' + id)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/service-office', data )
    return response.data
  },
  update: async (data) => {
    const response = await axiosInstance.put(`/service-office/${data.id}`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/service-office/${id}`)
    return response.data
  },
}